import { Lci3Report } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { Campaign } from '@features/campaigns';
import { ShapeProps, Slide } from '@features/powerpoint';
import { ImageWithMetadata } from '@features/powerpoint';
import { texts } from './campaign-overview/texts';
import { buildCampaignOverviewSlide } from '@features/executive-report/slides/campaign-overview';
import { theme } from '@features/executive-report/domain/theme';

export const DIMENSION_TEXT_OFFSET = 2.99;

export type CampaignOverviewSlideOptions = {
  campaign: Pick<Campaign, 'adSpend' | 'startDate' | 'endDate'>;
  report: Pick<Lci3Report, 'startDate' | 'reportDate' | 'visitMetrics'>;
  brandLogoWithMetadata: ImageWithMetadata | null;
  dimensionCounts: [number, number, number];
};

const buildDimensionShapes = (index: number): ShapeProps[] => [
  {
    shapeName: 'rect',
    options: {
      fill: {
        color: theme.colors.darkGray,
      },
      line: {
        color: theme.colors.inmarketGreen,
        width: 1,
      },
      h: 3.24,
      w: 2.71,
      x: 4.31 + index * DIMENSION_TEXT_OFFSET,
      y: 2.05,
    },
  },
  {
    shapeName: 'line',
    options: {
      line: {
        color: theme.colors.white,
        width: 1,
      },
      h: 0,
      w: 2.28,
      x: 4.52 + index * DIMENSION_TEXT_OFFSET,
      y: 3.26,
    },
  },
  {
    shapeName: 'rect',
    options: {
      fill: {
        color: theme.colors.inmarketGreen,
        transparency: 86,
      },
      h: 1.34,
      w: 2.28,
      x: 4.52 + index * DIMENSION_TEXT_OFFSET,
      y: 3.69,
    },
  },
];

export const campaignOverviewSlide = (
  options: CampaignOverviewSlideOptions
): Slide => {
  const dimensionShapes: ShapeProps[] = options.dimensionCounts.flatMap(
    (_, index) => buildDimensionShapes(index)
  );

  return buildCampaignOverviewSlide(
    texts(options),
    dimensionShapes,
    options.brandLogoWithMetadata,
    { x: 0.88, y: 2.05 }
  );
};
